import { CommonModule } from "@angular/common";
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  type AfterViewInit,
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  type ElementRef,
  EventEmitter,
  Input,
  type OnInit,
  Output,
  ViewChild,
  inject,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { IonicModule } from "@ionic/angular";
import { C_Banners } from "@models/C_banners";
import { GlobalVarsModel } from "@models/ModelGlobalsVar";
import { TranslateModule } from "@ngx-translate/core";
import { UserService } from "@providers/UserService";
import { NewBaseService } from "@providers/newBase.service";
import { DeviceService } from "@services/device.service";
import { SPORTS_PATHS } from "@shared-constants/routes";
import { Swiper, SwiperOptions } from "swiper";
@Component({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: "codere-slider",
  templateUrl: "./codere-slider.html",
  imports: [CommonModule, IonicModule, TranslateModule],
  standalone: true,
  styleUrls: ["./codere-slider.scss"],
})
export class CodereSliderComponent implements OnInit, AfterViewInit {
  @Input() slides;
  @Input() controls: boolean;
  @Output() clickedSlide: EventEmitter<any> = new EventEmitter();

  globalVars!: GlobalVarsModel;
  isDesktop = false;
  isSportSlider = false;
  swiperSliders: string[] = [];

  config: SwiperOptions = {
    loop: true,
    slidesPerView: "auto",
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    observer: true,
  };
  @ViewChild("swiper") swiperRef:
    | ElementRef<HTMLElement & { swiper?: Swiper } & { initialize: () => void }>
    | undefined;

  swiper?: Swiper;

  newBaseService = inject(NewBaseService);
  userService = inject(UserService);
  route = inject(ActivatedRoute);
  deviceService = inject(DeviceService);

  constructor() {
    this.newBaseService.getVars.subscribe((data: GlobalVarsModel) => {
      this.globalVars = data;
    });
    this.isSportSlider = this.route?.component.name === SPORTS_PATHS.HomePage || false;
    this.isDesktop = this.deviceService.isDesktop();
  }
  ngOnInit(): void {
    this.slides?.map((item: C_Banners) => {
      this.swiperSliders.push(item.Imagen);
    });

    this.config.allowTouchMove = !this.controls;
  }
  ngAfterViewInit(): void {
    const swiperEl = Object.assign(this.swiperRef?.nativeElement, this.config);
    swiperEl.initialize();
    this.swiper = this.swiperRef?.nativeElement.swiper;
  }
}
